export const groupBy = <T>(list: T[], getKey: (item: T) => string) =>
    list.reduce((previous, currentItem) => {
        const group = getKey(currentItem) as string;
        if (!previous[group]) previous[group] = [];
        previous[group].push(currentItem);
        return previous;
    }, {} as Record<string, T[]>);